module.exports = __webpack_public_path__ + "static/img/banner1.42c4828.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serve/banner1.jpg
// module id = lbOB
// module chunks = 0